import { combineReducers } from "redux";

import appliance from "./appliance";

export default combineReducers([ appliance ]);